import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { backendApi } from '../../redux/base.config'
import { HTTP } from '../../constants/HTTP/Http'
import { USER_API } from '../../constants/ENDPOINTS/EndPoints'

export const Authentication = backendApi.injectEndpoints({

    overrideExisting: true,
    baseQuery: fetchBaseQuery({ baseUrl: `${window.REACT_APP_BASE_URL}` }),
    endpoints: (builder) => ({
        Login: builder.mutation({
            query: (data) => ({
                url: USER_API.LOGIN,
                method: HTTP.POST,
                body: data,
            }),
        }),
        LoginVerifyOtp: builder.mutation({
            query: (data) => ({
                url: USER_API.LOGIN_VERIFY,
                method: HTTP.POST,
                params: data,
            }),
        }),
        Logout: builder.mutation({
            query: (data) => ({
                url: USER_API.LOGOUT,
                method: HTTP.GET,
                body: data,
            }),
        }),
        screenRoutes: builder.mutation({
            query: (data) => ({
                url: USER_API.SCREEN_ROUTES,
                method: HTTP.GET,
                body: data
            }),
        }),
    }),
})

export const {
    useLoginVerifyOtpMutation,
    useLoginMutation,
    useLogoutMutation,
    useScreenRoutesMutation,
    
} = Authentication
